/* Add-On Lab — per-product configuration.
   Replaces every Infinite Options set (mapping doc: mf-addon-widget-mapping.md).
   ASSIGN maps product handle -> list of set names; a handle in several sets
   gets them merged, in order. Handles not listed render nothing, so the
   widget is safe to embed on any product template. Dormant/unpublished
   handles are kept on purpose: drop products work again on re-publish.

   Section types:
   - product:   tiles from one product's variants (fountain pen accessories)
   - products:  tiles across several one-variant products (eraser plugs)
   - engraving: text field(s) + orientation, optional fee product; if the fee
                product has variants, orientation picks the variant
   - choice:    property-only picker, no product added (lead mechanism)

   The 'stand' set (Vertical Stand, product the-vertical-stand) rides on every
   pen/pencil handle EXCEPT fountain pens (the stand does not fit them), the
   fountain-pen-long-body part, and the 3-of-a-kind sets that already include
   a stand. Added 8/17/26.
*/
window.AddonLabConfig = (function () {
  var SETS = {

    /* ---- single-item engraving ---- */
    engrave1: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'engraving',
      blurb: 'Engraved on the item. Choose right- or left-handed so the text reads correctly in your hand.',
      items: [{ key: '' }]
    },
    engrave1Free: {
      type: 'engraving', title: 'Free Engraving', fee: null,
      blurb: 'Personalized engraving, on us (usually $15). Choose right- or left-handed so the text reads correctly in your hand.',
      items: [{ key: '' }]
    },
    engraveBapClip: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'engraving',
      blurb: 'Engraved on the pen body only — engraving is not available on clips. Choose right- or left-handed so the text reads correctly in your hand.',
      items: [{ key: '' }]
    },
    engraveZr: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'zirconium-engraving', maxLen: 35,
      blurb: 'Engraved on the pen. 35 characters is the recommended limit — longer engravings extend down the barrel.',
      items: [{ key: '' }]
    },
    fpEngrave: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'fountain-pen-engraving',
      blurb: 'Engraved on the pen. Choose right- or left-handed so the text reads correctly in your hand, and type the engraving text below.',
      items: [{ key: '' }]
    },

    /* ---- multi-item engraving sets ---- */
    engravePenPencil: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'engraving-2-items',
      blurb: 'Engrave one or both items. Choose right- or left-handed for each so the text reads correctly in your hand.',
      items: [{ key: 'Pencil' }, { key: 'Pen' }]
    },
    engravePenPencilFree: {
      type: 'engraving', title: 'Free Engraving', fee: null,
      blurb: 'Personalized engraving on either or both items, on us. Choose right- or left-handed for each.',
      items: [{ key: 'Pencil' }, { key: 'Pen' }]
    },
    engraveSet2: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'engraving-2-items',
      blurb: 'Engrave one or both items. Choose right- or left-handed for each so the text reads correctly in your hand.',
      items: [{ key: 'First Item' }, { key: 'Second Item' }]
    },
    engraveSet3Free: {
      type: 'engraving', title: 'Free Engraving', fee: 'engraving-3-items', sharedOrientation: true,
      blurb: 'Add your free engravings — any or all three items.',
      items: [{ key: 'Bolt Action' }, { key: 'Click Pen' }, { key: 'Click Pencil' }]
    },
    engraveCollectors: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'engraving-4-items', sharedOrientation: true,
      blurb: 'Engrave any or all four pieces of the set.',
      items: [{ key: 'Bronze' }, { key: 'Copper' }, { key: 'Stainless Steel' }, { key: 'Titanium' }]
    },
    engraveTiUltimate: {
      type: 'engraving', title: 'Personalized Engraving', fee: 'engraving-3-items-1', sharedOrientation: true,
      blurb: 'Engrave any or all three items in the collection.',
      items: [{ key: 'Pencil' }, { key: 'Fountain Pen' }, { key: 'Pen' }]
    },

    /* ---- eraser plugs (pencils) ---- */
    eraserPlug: {
      type: 'products', title: 'Eraser Plug', match: true,
      blurb: 'Every pencil ships with an eraser in it and five spares. For an ultra-minimalist look add an optional eraser plug that screws into the end of the knock instead of using an eraser.',
      handles: ['bronze-eraser-plug-add-on', 'copper-eraser-plug-add-on', 'stainless-steel-eraser-plug-add-on', 'titanium-eraser-plug-add-on']
    },
    eraserPlugZr: {
      type: 'products', title: 'Eraser Plug', match: true,
      blurb: 'Every pencil ships with an eraser in it and five spares. For an ultra-minimalist look add an optional eraser plug that screws into the end of the knock instead of using an eraser.',
      handles: ['zirconium-eraser-plug-add-on']
    },

    /* ---- property-only pickers ---- */
    leadMech: {
      type: 'choice', title: 'Lead Mechanism', propKey: 'Lead Mechanism',
      blurb: 'Choose the lead size for the pencil mechanism.',
      options: ['0.5mm', '0.7mm', '0.9mm']
    },

    /* ---- vertical stand (all pens/pencils except fountain pens) ---- */
    stand: {
      type: 'product', handle: 'the-vertical-stand', title: 'Vertical Stand', match: true,
      blurb: 'Machined from a solid block with a threaded Ultem core, it holds one pen or pencil upright on your desk.'
    },

    /* ---- fountain pen accessory sections (already live) ---- */
    fpNib: {
      type: 'product', handle: 'fountain-pen-nibs-add-on', title: 'Extra Nib', match: false,
      blurb: 'Every pen already comes with a stainless steel EF nib (no engraving) at no charge. Add a spare or an upgraded nib here — some are offered with or without the logo engraving.'
    },
    fpLongBody: {
      type: 'product', handle: 'fountain-pen-long-body', title: 'Long Body', match: true,
      blurb: 'The standard pen includes a mini converter. If you want a full-size converter, you need the long body — it comes with one.'
    },
    fpBodyCap: {
      type: 'product', handle: 'fountain-pen-body-cap', title: 'Body Cap', match: true,
      blurb: 'An extension piece for writing unposted.'
    },
    fpLoopEnd: {
      type: 'product', handle: 'fountain-pen-loop-end', title: 'Loop End', match: true,
      blurb: 'Replaces the standard end so you can clip the pen to a lanyard or keyring.'
    },
    fpSmoothGrip: {
      type: 'product', handle: 'fountain-pen-smooth-grip', title: 'Smooth Grip Section', match: true,
      blurb: 'A smooth alternative to the standard grooved grip.'
    },
    fpMiniConverter: {
      type: 'product', handle: 'fountain-pen-mini-converter', title: 'Extra Mini Converter', match: false,
      blurb: 'One mini converter is already included with every pen. Add a spare here.'
    }
  };

  var FP = ['fpEngrave', 'fpNib', 'fpLongBody', 'fpBodyCap', 'fpLoopEnd', 'fpSmoothGrip', 'fpMiniConverter'];

  var ASSIGN = {
    /* fountain pens (live since 8/12) */
    'fountain-pen': FP,
    'modern-fuel-fountain-pen': FP,
    'aluminum-modern-fuel-fountain-pen-anodized-color-edition': FP,
    'anodized-color-edition': FP,
    'aluminum-modern-fuel-fountain-pen-anodized': FP,

    /* single-item engraving, $15 */
    'the-pen': ['engrave1', 'stand'],
    'the-pencil': ['engrave1', 'eraserPlug', 'stand'],
    'the-pencil-with-mechanism-options': ['engrave1', 'stand'],
    'the-bolt-action': ['engrave1', 'stand'],
    'the-pen-mf': ['engrave1', 'stand'],
    'the-pencil-mf': ['engrave1', 'eraserPlug', 'stand'],
    'the-pencil-with-mechanism-options-mf': ['engrave1', 'stand'],
    'the-bolt-action-mf': ['engrave1', 'stand'],
    'poseidon': ['engrave1', 'stand'],
    'athena': ['engrave1', 'stand'],
    'hades': ['engrave1', 'stand'],
    'copper-click-pen': ['engrave1', 'stand'],
    'bronze-click-pencil': ['engrave1', 'stand'],
    'copper-click-pen-1': ['engrave1', 'stand'],
    'titanium-click-pencil': ['engrave1', 'stand'],
    'titanium-bolt-action-pen': ['engrave1', 'stand'],
    'bronze-bolt-action-pen': ['engrave1', 'stand'],
    'copper-bolt-action-pen-1': ['engrave1', 'stand'],
    'stainless-steel-click-pen': ['engrave1', 'stand'],
    'bronze-click-pen': ['engrave1', 'stand'],
    'blackhawk-green-bolt-action': ['engrave1', 'stand'],
    'boysenberry-purple-bolt-action-pen': ['engrave1', 'stand'],
    'modern-fuel-stainless-bolt-action-pen-with-clip': ['engrave1', 'stand'],
    'stainless-steel-bolt-action-pen-with-clip': ['engrave1', 'stand'],
    'grooved-click-pencil': ['engrave1', 'eraserPlug', 'stand'],
    'champagne-gold-with-clip-b-stock': ['engrave1', 'stand'],
    'fountain-pen-long-body': ['engrave1'],
    'adjustable-bolt-action-pen-clip': ['engrave1', 'stand'],
    'studio-bronze-pencil': ['engrave1', 'stand'],
    'zirconium-click-pencil': ['engrave1', 'eraserPlugZr', 'stand'],
    'the-click-pencil': ['engrave1', 'stand'],

    /* single-item engraving, free */
    'fully-loaded-pencil': ['engrave1Free', 'stand'],
    'fully-loaded-bolt-action-pen': ['engrave1Free', 'stand'],
    'bolt-action-pen-early-access': ['engrave1Free', 'stand'],
    'click-pencil': ['engrave1Free', 'stand'],
    'click-pen-early-access': ['engrave1Free', 'stand'],
    'fully-loaded-bolt-action-pen-early-access': ['engrave1Free', 'stand'],
    'fully-loaded-click-pen-early-access': ['engrave1Free', 'stand'],
    'fully-loaded-click-pencil-early-access': ['engrave1Free', 'stand'],
    'ultimate-click-pencil-set-early-access': ['engrave1Free', 'stand'],
    'fully-loaded-classic-pen': ['engrave1Free', 'stand'],
    'ultimate-click-pencil-set': ['engrave1Free', 'stand'],

    /* bolt action pen w/ clip ($15, pen only) */
    'bolt-action-pen-clip-kit': ['engraveBapClip', 'stand'],
    'adjustable-bolt-action-pen': ['engraveBapClip', 'stand'],
    'titanium-step-nose-bolt-action-pen-with-clip-energel': ['engraveBapClip', 'stand'],

    /* zirconium aBAP ($30) */
    'zirconium-adjustable-bolt-action-pen': ['engraveZr', 'stand'],

    /* pencil + pen sets ($30) */
    'pen-pencil': ['engravePenPencil', 'stand'],
    'the-modern-fuel-pencil': ['engravePenPencil', 'eraserPlug', 'stand'],
    'the-modern-fuel-pencil-mf': ['engravePenPencil', 'eraserPlug', 'stand'],
    'pen-pencil-mf': ['engravePenPencil', 'eraserPlug', 'stand'],
    'pencil-pen-mf': ['engravePenPencil', 'eraserPlug', 'stand'],
    'modern-fuel-bolt-action-pen-mf': ['engravePenPencil', 'stand'],
    'bolt-action-pen-click-pencil': ['engravePenPencil', 'stand'],
    'pencil-pen': ['engravePenPencil', 'stand'],
    'modern-fuel-pencil-kit': ['engravePenPencil', 'stand'],
    'modern-fuel-pencil-kit-bolt-action-pen': ['engravePenPencil', 'eraserPlug', 'stand'],
    'matte-black-click-pencil-bolt-action-pen': ['engravePenPencil', 'stand'],
    'forest-explorer-limited-edition': ['engravePenPencil', 'stand'],
    'modern-fuel-pencil-kit-grooved': ['engravePenPencil', 'eraserPlug', 'stand'],

    /* pencil + pen, free */
    'the-pen-free-engraving': ['engravePenPencilFree', 'stand'],
    'the-pencil-free-engraving': ['engravePenPencilFree', 'eraserPlug', 'stand'],
    'the-pen-free-engraving-mf': ['engravePenPencilFree', 'stand'],
    'the-pencil-free-engraving-mf': ['engravePenPencilFree', 'eraserPlug', 'stand'],
    'bolt-action-pen-free-engraving': ['engravePenPencilFree', 'stand'],
    'modern-fuel-bolt-action-pen': ['engravePenPencilFree', 'stand'],

    /* set of two ($30) */
    'pen-pencil-set': ['engraveSet2', 'stand'],
    'two-pencils': ['engraveSet2', 'stand'],
    'two-pens': ['engraveSet2', 'stand'],
    'two-pencils-mf': ['engraveSet2', 'stand'],
    'two-pens-mf': ['engraveSet2', 'stand'],
    'two-bolt-action-pens': ['engraveSet2', 'stand'],
    'bolt-action-pen-click-pencil-titanium-set': ['engraveSet2', 'leadMech', 'stand'],

    /* 3-item set, free */
    '3-of-a-kind-stand-engraving-early-access': ['engraveSet3Free'],
    '3-of-a-kind-stand-engraving': ['engraveSet3Free'],
    'bolt-action-pencil-pen': ['engraveSet3Free', 'stand'],

    /* collector's sets ($60) */
    'the-pen-collectors-set': ['engraveCollectors', 'stand'],
    'the-pencil-collectors-set': ['engraveCollectors', 'stand'],
    'the-pen-collectors-set-mf': ['engraveCollectors', 'stand'],
    'the-pencil-collectors-set-mf': ['engraveCollectors', 'stand'],

    /* ti ultimate collection ($30 bundle) */
    'ultimate-titanium-collection': ['engraveTiUltimate', 'leadMech', 'stand'],

    /* stand only — pens/pencils that never had an Infinite Options set (8/17/26) */
    'modern-fuel-bolt-action-pen-1': ['stand'],
    'the-bolt-action-with-legends': ['stand'],
    'modern-fuel-pencil': ['stand'],
    'modern-fuel-pen': ['stand'],
    'two-pens-1': ['stand'],
    'click-pencil-collectors-set': ['stand'],
    'enchanted-emerald-titanium-click-pencil': ['stand'],
    'champagne-gold-bolt-action-pen': ['stand'],
    'zirconium-pencil-with-tidam-knock': ['stand'],
    'zirctropic-adjustable-bolt-action-pen': ['stand'],
    'adjustable-bolt-action-pen-titanium-with-tidam-knock': ['stand']
  };

  return {
    forHandle: function (handle) {
      var names = ASSIGN[handle] || [];
      return names.map(function (n) {
        var s = SETS[n];
        var copy = {};
        for (var k in s) copy[k] = s[k];
        copy.setName = n;
        return copy;
      });
    }
  };
})();
